import { ref, reactive, computed, onMounted, watch } from 'vue'
import { defineStore } from 'pinia'

import{useSettings} from '@store/settings'
const $settings = useSettings()

import { useRoute } from 'vue-router'

export const useOnboarding = defineStore('onboarding', () => {
    const route = useRoute()

    const isBusinessChanged = ref(false)

    watch(() => $settings.business, () => {
        if ((route.name == 'onboarding.business.info' || route.name == 'onboarding.business.address')) {
            isBusinessChanged.value = true
        }
        console.log('changed',isBusinessChanged.value)
    }, { deep: true })

    // Return.
    return {
        isBusinessChanged
    }

})
